import React from 'react';
import PropTypes from 'prop-types';

import 'inventory-listing/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsButtons/YearsButtons/ModelButton/ModelButton.scss';

const ModelButton = ({ isSelected, value, handleChange }) => {
    const cssClasses = ['model-button'];

    if (isSelected) {
        cssClasses.push('selected is-price');
    }

    return (
        <button
            className={cssClasses.join(' ')}
            onClick={() => {
                handleChange(value);
            }}
        >
            {value}
        </button>
    );
};

ModelButton.propTypes = {
    value: PropTypes.number.isRequired,
    isSelected: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
};

ModelButton.displayName = 'ModelButton';

export default ModelButton;



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/ListingFiltersYears/ListingFiltersYearsButtons/YearsButtons/ModelButton/ModelButton.jsx